export default __webpack_public_path__ + "static/media/iphone-xmas-gift.09b3b288.png";